import { createSelector } from "reselect"
import { map } from "lodash"
import { getCurrencyScaleForValues, makeScaledFormatterSelector, type ValueFormatter } from "helpers/formatters/currency-scale"
import { METRIC_TYPES } from "helpers/assets/constants"
import { getDetails } from "./index"

interface ScaleProps {
  metricType?: string
  formatter?: ValueFormatter
}

const getMetricType = (_: unknown, props: ScaleProps) => props.metricType

export const getDetailsCurrencyScale = createSelector(
  [getDetails, getMetricType],
  (details, metricType): string | null => metricType === METRIC_TYPES.CURRENCY_EXPOSURE
    ? getCurrencyScaleForValues(map(details, "value"))
    : null,
)

export const getDailyDetailsFormatter = makeScaledFormatterSelector(getDetailsCurrencyScale)
